import React from 'react';

import {Box, Typography, Paper, Stack, Skeleton} from 'views/components';
import {CreditCardOutlined as CreditCardOutlinedIcon} from 'views/icons';
import {Translate} from 'views/module';

const ReimbursementTileSkeleton = () => {
  return (
    <Paper sx={{p: 2, mb: 2, borderRadius: 4}}>
      <Stack spacing={2} sx={{px: 2, py: 1}}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <CreditCardOutlinedIcon sx={{width: 24, height: 24, color: '#b0b0b0'}} />
          <Typography variant="h6">
            <Translate expression='schedule.eventDetail.ReimbursementSection.Title' />
          </Typography>
        </Stack>
        <Box
          sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 3,
            bgcolor: 'background.paper',
            overflow: 'hidden',
          }}
        >
          {/* Header: title and amount */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 3,
              pt: 3,
              pb: 1,
            }}
          >
            <Skeleton variant="text" width={150} height={32} />
            <Skeleton variant="text" width={100} height={32} />
          </Box>

          {/* Images placeholder */}
          <Box
            sx={{
              px: 4,
              pb: 3,
            }}
          >
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rounded" width={120} height={120} />
            </Stack>
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};

export default ReimbursementTileSkeleton;
